import UserStories from '@elem/ui/ef-user-stories-youtube-author';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.ListB');
    const { t: t2 } = useLang('theProduct.Banner');
    const { locale = 'us' } = useRouter();
    let listA: any = [
        {
            title: t('video_1_title'),
            text: t('video_1_desc'),
            author: t('video_1_author'),
            link: t('video_1_link'),
            // avatar: t('video_1_avatar'),
            imgPC: 'https://websiteoss.ecoflow.com/upload/image/1725603235932/pc_pros_01.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1725603764343/m_pros_01.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1725603764343/m_pros_01.jpg',
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1725603811974/Avatar_DA.png',
        },
        {
            title: t('video_2_title'),
            text: t('video_2_desc'),
            author: t('video_2_author'),
            link: t('video_2_link'),
            // avatar: t('video_2_avatar'),
            imgPC: 'https://websiteoss.ecoflow.com/upload/image/1725603236102/pc_pros_02.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1725603764157/m_pros_02.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1725603764157/m_pros_02.jpg',
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1725603812160/Avatar_JW.png',
        },
        {
            title: t('video_3_title'),
            text: t('video_3_desc'),
            author: t('video_3_author'),
            link: t('video_3_link'),
            // avatar: t('video_3_avatar'),
            imgPC: 'https://websiteoss.ecoflow.com/upload/image/1725603235753/pc_pros_03.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1725603764781/m_pros_03.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1725603764781/m_pros_03.jpg',
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1725603812563/Avatar_NS.png',
        },
        {
            title: t('video_4_title'),
            text: t('video_4_desc'),
            author: t('video_4_author'),
            link: t('video_4_link'),
            // avatar: t('video_4_avatar'),
            imgPC: 'https://websiteoss.ecoflow.com/upload/image/1725603236292/pc_pros_04.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1725603764547/m_pros_04.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1725603764547/m_pros_04.jpg',
            avatar: 'https://websiteoss.ecoflow.com/upload/image/1725603812364/Avatar_MMP.png',
        },
    ];
    if (locale == 'au') {
        listA = [
            {
                title: `EcoFlow DELTA 2 Max | Finally, a Lightweight & Compact Lithium Power Station!`,
                text: `EcoFlow DELTA 2 Max | Finally, a Lightweight & Compact Lithium Power Station!`,
                link: 'https://www.youtube.com/embed/rmZtLu9YZf4',
                imgPC: 'https://i.ytimg.com/vi/rmZtLu9YZf4/maxresdefault.jpg',
                avatar: 'https://yt3.ggpht.com/GtQ7lkQycRrb81Tj2ZGa7vn07SJTPfLhYknZlN4uuH3Qgzm73wQFUV9XAAJHRgtU8BWaUTVG=s68-c-k-c0x00ffffff-no-rj',
                author: 'Explore Bound',
            },
            {
                title: 'EcoFlow - Is It WORTH It? Can It EXPAND Our Battery System?',
                text: 'EcoFlow - Is It WORTH It? Can It EXPAND Our Battery System?',
                link: 'https://www.youtube.com/embed/ZiSdr0IEEyg',
                imgPC: 'https://i.ytimg.com/vi/ZiSdr0IEEyg/maxresdefault.jpg',
                avatar: 'https://yt3.ggpht.com/QGvYBO6hJ_SPbykzsWId29vWtDYklvrDUcY6DB0pMWyiD8xoY9xPGaQanXaOwuUq_JRtSZVgFA=s68-c-k-c0x00ffffff-no-rj',
                author: `Five Down Under - Travelling Australia`,
            },
            {
                title: 'Power Your Ham Radio Anywhere with EcoFlow DELTA 2',
                text: 'Power Your Ham Radio Anywhere with EcoFlow DELTA 2',
                link: 'https://www.youtube.com/embed/D-gvPrlLRXc',
                imgPC: 'https://i.ytimg.com/vi/D-gvPrlLRXc/maxresdefault.jpg',
                avatar: 'https://yt3.ggpht.com/ytc/AIdro_nGgyDLVC4oyj6qCQlTB0vsw_84nIkpW-lMwy8a-NAIug=s48-c-k-c0x00ffffff-no-rj',
                author: 'Ham Radio DX',
            },
            {
                title: 'Ecoflow Delta 2 And Next Gen 220 Watt Solar Panel',
                text: 'Ecoflow Delta 2 And Next Gen 220 Watt Solar Panel',
                link: 'https://www.youtube.com/embed/vtEIeSJ8UWY?si=7JmpxxzWmdYmezxA',
                imgPC: 'https://i.ytimg.com/vi/vtEIeSJ8UWY/maxresdefault.jpg',
                avatar: 'https://yt3.ggpht.com/ytc/AIdro_mTStZxFZ59rOCLZXIa79xy7JEgJqt7Gjx2zVKArcUZ7Pk=s48-c-k-c0x00ffffff-no-rj',
                author: 'robbiefishing',
            },
        ];
    }

    return (
        <div className={styles.TheComp}>
            <UserStories title={t('title')} lists={listA} gtm_position={t2('title')} />
        </div>
    );
}
